<div class="container">
	<ion-chip (click)="dismiss(false)" class="cross">
		<ion-icon src="../../../assets/topgolf/close_hover.svg"></ion-icon>
	</ion-chip>

	@if (title) {
		<h1 class="title">{{ title }}</h1>
	}
	<div (click)="dismiss(true)" class="button button_main">
		{{ isVenueOpenFunc() }}
	</div>
</div>
